module.exports = __webpack_public_path__ + "@/assets/img/02.7657bf6d.svg";